export default {
    monthly: 'Mensal',
    yearly: 'Anual',
    month: 'mês',
    year: 'ano',
    title: 'Planos de Assinatura',
    current_plan: 'Plano Atual',
    selected_plan: 'Plano selecionado',
    status: 'Status',
    statuses: {
        active: 'Ativo',
        past_due: 'Pagamento Pendente',
        canceled: 'Cancelado',
    },
    cancel: 'Cancelar Assinatura',
    confirm_cancel: 'Tem certeza que deseja cancelar sua assinatura?',
    available_plans: 'Planos Disponíveis',
    select_plan: 'Selecionar Plano',
    creditsPerMonth: 'créditos / mês',
    postsPerMonth: 'até {count} posts / mês',
    brandAccountsMax: 'até {max} contas de marca',
    includedBonusesMonthly: '{count} ações bônus inclusas / mês',
    includedBonusesUnlimited: 'Ações bônus inclusas ilimitadas',
    features: {
        personalized_workouts: 'Treinos personalizados',
        exercise_library: 'Biblioteca de exercícios',
        progress_tracking: 'Acompanhamento de progresso',
        nutrition_guidance: 'Orientações nutricionais',
        priority_support: 'Suporte prioritário',
    },
};
